import React, { Suspense, useRef } from 'react';
import { Canvas } from 'react-three-fiber';
import { Sky, Box, PositionalAudio } from 'drei';
import { Physics } from 'use-cannon';

import { Ground } from './components/Ground';
import { Player } from './components/Player';
import { Hud } from './components/Hud';

function App() {

  const audioSource = useRef();

  return (
    <Canvas shadowMap sRGB onClick={(e) => {(audioSource.current.context.resume())}}>
      <Sky sunPosition={[100, 20, 100]} />
      <ambientLight intensity={0.25} />
      <pointLight castShadow intensity={0.7} position={[100, 100, 100]} />
      <Hud position={[0, 0, -2]} />
      <Physics gravity={[0, -30, 0]}>
        <Ground position={[0, 0.5, 0]} />
        <Suspense fallback={null}>
            <Box position={[0, 1.5, 10]}>
              <meshStandardMaterial attach="material" />
              <PositionalAudio ref={audioSource} url="/376737_Skullbeatz___Bad_Cat_Maste.mp3"/>
            </Box>
          </Suspense>
        <Player position={[0, 3, 10]} />
      </Physics>
    </Canvas>
  );
}

export default App;
